import React, { memo } from 'react';
import Button from '@components/@core/AnimatedButton';
import { useDispatch, useSelector } from 'react-redux';
import AppActions from '~/actions/app';
import CheckBox from '@components/@core/CheckBox';
import Icon from '@components/@core/Icon';

const FRANCHISES = [
    { id: 'acura', label: 'Acura' },
    { id: 'alfa romeo', label: 'Alfa Romeo' },
    { id: 'audi', label: 'Audi' },
    { id: 'bmw', label: 'BMW' },
    { id: 'buick', label: 'Buick' },
    { id: 'candillac', label: 'Candillac' },
    { id: 'chevrolet', label: 'Chevrolet' },
    { id: 'chrysler', label: 'Chrysler' },
    { id: 'dodge', label: 'Dodge' },
    { id: 'fiat', label: 'FIAT' },
    { id: 'ford', label: 'Ford' },
    { id: 'genesys', label: 'Genesys' },
    { id: 'gmc', label: 'GMC' },
    { id: 'honda', label: 'Honda' },
    { id: 'hyundai', label: 'Hyundai' },
    { id: 'infiniti', label: 'Infiniti' },
    { id: 'jaguar', label: 'Jaguar' },
    { id: 'jeep', label: 'Jeep' },
    { id: 'kia', label: 'KIA' },
    { id: 'land rover', label: 'Land Rover' },
    { id: 'lexus', label: 'Lexus' },
    { id: 'lincoln', label: 'Lincoln' },
    { id: 'mazerati', label: 'Mazerati' },
    { id: 'mazda', label: 'Mazda' },
    { id: 'mercedes-benz', label: 'Mercedes-Benz' },
    { id: 'mini', label: 'MINI' },
    { id: 'mitsubishi', label: 'Mitsubishi' },
    { id: 'nissan', label: 'Nissan' },
    { id: 'porsche', label: 'Porsche' },
    { id: 'smart', label: 'Smart' },
    { id: 'subaru', label: 'Subaru' },
    { id: 'toyota', label: 'Toyota' },
    { id: 'volkswagen', label: 'Volkswagen' },
    { id: 'volvo', label: 'Volvo' },
];

const FranchCard = ({ franchises, onChecked }) => {
    const dispatch = useDispatch();
    const handleFranchises = (franchisee) => (evt) => {
        const checked = evt.target.checked;
        onChecked(franchisee, checked);
    };

    const staticAddFranchise = (obj) => {
        FRANCHISES.push(obj);
    };
    const handleAddFranchise = () => {
        const payload = {
            type: 'Add Franchise',
            callBack: staticAddFranchise,
        };
        dispatch(AppActions.modalRequest(payload));
    };

    return (
        <div className="card mb-3 vdra-franchises">
            <p className="dsl-b22 bold">Franchises</p>
            <div className="d-flex flex-wrap">
                {FRANCHISES.map((franchisee, idx) => (
                    <div className="vdra-w ms-3" key={`fc${idx}`}>
                        <CheckBox
                            className="dsl-b14 py-2"
                            id={franchisee.id}
                            key={franchisee.id}
                            title={franchisee.label}
                            checked={franchises.includes(franchisee.label)}
                            onChange={handleFranchises(franchisee)}
                            size="small"
                        />
                    </div>
                ))}
            </div>
            <div className="d-flex ai-center">
                <Button className="ml-auto" type="low" size="small" onClick={handleAddFranchise}>
                    <Icon name="fas fa-plus me-2" size={10} color="#376caf" />
                    ADD FRANCHISE
                </Button>
            </div>
        </div>
    );
};

export default memo(FranchCard);
